export default __webpack_public_path__ + "static/media/Mycloudwallet_logo.ba2da6d5.png";